import { configureStore } from '@reduxjs/toolkit'
import initReducer from '../state/initSlice'
import onboardingReducer from '../state/onboarding'
import layoutReducer from '../state/layout'
import percentMaxCalculatorReducer from '../state/percentMaxCalculator'
import eventsReducer from '../state/events'
import usersReducer from '../features/users/usersSlice'
import complianceReducer from '../features/compliance/complianceSlice'
import liveClassesReducer from '../features/LiveClasses/liveClassesSlice'
import clientNotesReducer from '../state/clientNotesSlice'
import accountTagsReducer from '../state/accountTagsSlice'
import brandingReducer from '../state/branding'
import messengerReducer from '../state/messengerSlice'
import gymCalendarReducer from '../features/GymCalendar/slice'
import todaysEventsReducer from '../features/todaysEvents/TodaysEventsSlice'
import progressReducer from '../features/progress/progressSlice'
import photoReelReducer from '../features/photoReel/photoReelSlice'
import poseCamReducer from '../features/poseCam/poseCamSlice'
import picturesReducer from '../features/pictures/picturesSlice'
import programsReducer from '../features/programs/programsSlice'
import programAddEditReducer from "../features/ProgramsAddEdit/ProgramsAddEditSlice"
import eventsViewReducer from '../features/eventsView/eventsViewSlice'
import chatReducer from '../features/chat/chatSlice'
import achievementsReducer from '../features/achievements/achievementsSlice'
import reactionsReducer from '../features/reactions/reactionsSlice'
import groupFeedReducer from '../features/groupFeed/groupFeedSlice'
import exerciseListReducer from '../features/exerciseList/exerciseListSlice'
import viewPicturesReducer from '../features/viewPictures/viewPicturesSlice'
import recipesReducer from '../features/recipes/recipesSlice'
import profileReducer from '../features/profile/profileSlice'
import settingsReducer from '../features/settings/settingsSlice'
import messageCenterReducer from '../features/MessageCenter/messageCenterSlice'
import maxClassScheduleReducer from '../features/maxClassSchedule/maxClassScheduleSlice'
import exerciseLibraryReducer from '../state/exerciseLibrary'
import foodLibraryReducer from '../state/foodLibrary'
import parQReducer from "../features/parQ/parQSlice"
import newMessageDropdownReducer from "../features/NewMessageDropdown/slice"
import notificationDashboardReducer from "../features/NotificationDashboard/slice"
import metricsReducer__DEPRECATED from "../state/metricListSlice"
import paymentsReducer from '../features/FinancialsDashboard/Payments/paymentsSlice'
import sessionsReducer from '../features/FinancialsDashboard/Sessions/sessionsSlice'
import activeSubscriptionsReducer from '../features/FinancialsDashboard/Subscriptions/activeSubscriptionsSlice'
import availableSubscriptionsReducer from '../features/FinancialsDashboard/Subscriptions/availableSubscriptionsSlice'
import invoicesReducer from '../features/FinancialsDashboard/Invoices/slice'
import financialsDashboardReducer from '../features/FinancialsDashboard/financialsDashboardSlice'
import packagesReducer from '../features/FinancialsDashboard/Packages/packagesSlice'
import apiStatusSlice from "../state/apiStatusSlice"
import blogSlice from "../state/blogSlice"
import billingReducer from '../features/FinancialsDashboard/Billing/slice'
import customFormsReducer from "../state/customFormsSlice"
import SchedulerSlice from "../state/schedulerSlice"
import schedulerSlice from '../state/schedulerSlice'
import merchandiseReducer from '../features/FinancialsDashboard/Products/merchandiseSlice'
import purchaseFormsReducer from '../features/FinancialsDashboard/PurchaseForms/slice'
import wearableReducer from '../state/wearableSlice'
import workoutGuiderReducer from '../state/workoutGuiderSlice'
import exerciseRecorderReducer from '../features/ExerciseRecorder/slice'
import memoRecorderReducer from '../features/MemoRecorder/slice'
import videoModalReducer from '../features/VideoModal/slice'
import clientEmailsReducer from '../state/clientEmailsSlice'
import MAXFoodsReducer from '../features/foodList/MAXSlice'
import aiReducer from '../features/AIDemo/slice'
import externalResourcesReducer from '../state/externalResourcesSlice'
import trainerPageSlice from "../state/trainerPageSlice"
import payInvoiceReducer from '../features/PayInvoice/slice'
import metricsReducer from '../features/Metrics/slice'
import resourceLibraryReducer from '../features/ResourceLibrary/slice'
import growthReducer from '../features/Growth/slice'
import onDemandReducer from '../features/OnDemand/slice'
import activityCountReducer from '../features/NotificationBell/slice'
import customizationDashboardReducer from '../features/CustomizationDashboard/slice'
import crashLoggingReducer from '../features/crashLogging/slice'

import { getDefaultMiddleware } from '@reduxjs/toolkit'
import crashLoggingMiddleware from '../features/crashLogging/middleware'

export default configureStore({
	reducer: {
		init:initReducer,
		onboarding:onboardingReducer,
		users:usersReducer,
		todaysEvents:todaysEventsReducer,
		progress:progressReducer,
		pictures:picturesReducer,
		viewPictures:viewPicturesReducer,
		photoReel:photoReelReducer,
		poseCam:poseCamReducer,
		compliance: complianceReducer,
		accountTags: accountTagsReducer,
		clientNotes: clientNotesReducer,
		programs:programsReducer,
		programEvents: programAddEditReducer,
		achievements:achievementsReducer,
		chat:chatReducer,
		reactions:reactionsReducer,
		groupFeed:groupFeedReducer,
		events:eventsViewReducer,
		exercise:exerciseListReducer,
		messenger:messengerReducer,
		recipes:recipesReducer,
		maxClassSchedule: maxClassScheduleReducer,
		profile:profileReducer,
		settings:settingsReducer,
		branding:brandingReducer,
		layout:layoutReducer,
		allEvents:eventsReducer,
		exerciseLibrary:exerciseLibraryReducer,
		foodLibrary:foodLibraryReducer,
		percentMaxCalculator:percentMaxCalculatorReducer,
		parQ: parQReducer,
		metrics: metricsReducer__DEPRECATED,
		allMetrics: metricsReducer,
		newMessageDropdown:newMessageDropdownReducer,
		payments: paymentsReducer,	
		sessions: sessionsReducer,	
		liveClasses:liveClassesReducer,
		packages: packagesReducer,
		messageCenter:messageCenterReducer,
		apiStatus: apiStatusSlice,
		posts: blogSlice,
		billing: billingReducer,
		activeSubscriptions:activeSubscriptionsReducer,
		availableSubscriptions:availableSubscriptionsReducer,
		scheduler: schedulerSlice, 
		trainerPage: trainerPageSlice,
		customForms: customFormsReducer,
		merchandise: merchandiseReducer,
		wearable: wearableReducer,
		exerciseRecorder: exerciseRecorderReducer,
		workoutGuider:workoutGuiderReducer,
		memoRecorder:memoRecorderReducer,
		videoModal:videoModalReducer,
		clientEmails: clientEmailsReducer,
		MAXFoods:MAXFoodsReducer,
		financialsDashboard:financialsDashboardReducer,
		externalResources: externalResourcesReducer,
		notificationDashboard:notificationDashboardReducer,
		ai:aiReducer,
		payInvoice:payInvoiceReducer,
		invoices:invoicesReducer,
		resourceLibrary:resourceLibraryReducer,
		activityCount:activityCountReducer,
		onDemand:onDemandReducer,
		purchaseForms:purchaseFormsReducer,
		customizationDashboard:customizationDashboardReducer,
		crashLogging:crashLoggingReducer,
		gymCalendar:gymCalendarReducer,
		growth:growthReducer
	},
	middleware: [...getDefaultMiddleware(), crashLoggingMiddleware]
})
